module.exports = __webpack_public_path__ + "static/img/headIcon.e79b1dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/headIcon.png
// module id = S3WP
// module chunks = 1